<template>
  <button
    class="simon-button"
    @mousedown="activateButton"
    @mouseup="deactivateButton"
    @mouseout="deactivateButton"
    @touchstart="activateButton"
    @touchleave="deactivateButton"
    @touchend="deactivateButton"
    @touchmove="deactivateButton"

    :class="[color, {'activated':isActive}]">
    <img
      :class="{hidden:activate}"
      :src="btnPath">
    <img
      :class="{hidden:!activate}"
      :src="btnPressedPath">
  </button>
</template>

<script>
import audioContext from '../api/audio-context'
import BlueBtn from '../assets/btn-blue.svg'
import BluePressedBtn from '../assets/btn-blue-pressed.svg'
import RedBtn from '../assets/btn-red.svg'
import RedPressedBtn from '../assets/btn-red-pressed.svg'
import GreenBtn from '../assets/btn-green.svg'
import GreenPressedBtn from '../assets/btn-green-pressed.svg'
import YellowBtn from '../assets/btn-yellow.svg'
import YellowPressedBtn from '../assets/btn-yellow-pressed.svg'

export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    color: {
      type: String,
      required: true,
      validator (value) {
        return ['green', 'blue', 'red', 'yellow'].includes(value)
      }
    },
    activate: {
      type: Boolean,
      default: false
    },
    audioFrequency: {
      type: Number,
      required: true,
      default: 100
    },
    beepTime: {
      type: Number,
      default: 1
    },
    beepVolume: {
      type: Number,
      default: 0.1
    }
  },
  data () {
    return {
      context: null,
      oscillator: null,
      volume: null,
      isActive: false,
      blocked: false, // A block to prevent double events in touch screens
      faces: {
        blue: {
          normal: BlueBtn,
          pressed: BluePressedBtn
        },
        red: {
          normal: RedBtn,
          pressed: RedPressedBtn
        },
        green: {
          normal: GreenBtn,
          pressed: GreenPressedBtn
        },
        yellow: {
          normal: YellowBtn,
          pressed: YellowPressedBtn
        }
      }
    }
  },
  computed: {
    btnPath () {
      return this.faces[this.color].normal
    },
    btnPressedPath () {
      return this.faces[this.color].pressed
    }
  },
  watch: {
    activate (val) {
      if (val) {
        this.playAudio()
      } else {
        this.stopAudio()
      }
    }
  },
  mounted () {
    this.oscillator = audioContext.createOscillator()
    this.oscillator.type = 'square' // this is the default - also square, sawtooth, triangle
    this.oscillator.frequency.value = this.audioFrequency // Hz
    this.volume = audioContext.createGain()
    this.volume.connect(audioContext.destination) // connect it to the destination
    this.oscillator.connect(this.volume)
    this.volume.gain.value = 0
    this.oscillator.start() // start the oscillator
  },
  beforeDestroy () {
    this.stopAudio()
  },
  methods: {
    activateButton (event) {
      if (!this.isActive && !this.blocked) {
        this.isActive = true
        this.$emit('buttonActivated', this.id)
      }
    },
    deactivateButton (event) {
      if (this.isActive && !this.blocked) {
        this.isActive = false
        this.blocked = true
        this.$emit('buttonDeactivated', this.id)
        window.setTimeout(() => {
          this.blocked = false
        }, 100)
      }
    },
    playAudio () {
      this.volume.gain.value = this.beepVolume
    },
    stopAudio () {
      this.volume.gain.value = 0
    }
  }
}
</script>

<style lang="scss" scoped>
$blue-color: blue;
$red-color: red;
$green-color: rgb(0, 223, 0);
$yellow-color: yellow;
.simon-button {
  display: inline-block;
  width: 100%;
  max-width: 300px;
  border: none;
  background-color: transparent;
  overflow: hidden;
  position: relative;
  padding: 6px;
  h1 {
    position: absolute;
    color: white;
    z-index: 1000;
  }
  .hidden {
    opacity: 0;
    position: absolute;
  }
  &:focus {
    border: none;
    outline: none;
  }
  &.blue {
    top: 0;
    left: 0;
  }

  &.red,
  &.green {
    text-align: right;
  }
  img {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
    pointer-events: none;
    width: 100%;
  }
  &.activated {
    .face {
      path {
        filter: url(#brightGradient);
      }
    }
    .border {
      path {
        filter: url(#glow);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/simon-game/components/simon-button.vue